var exports = {
  "zr": "AudioWaveform.module__root___S215TW",
  "Ji": "AudioWaveform.module__canvas___S215TW",
  "r1": "AudioWaveform.module__selection___S215TW",
  "EP": "AudioWaveform.module__selectionDragging___S215TW",
  "p$": "AudioWaveform.module__handle___S215TW",
  "lG": "AudioWaveform.module__playhead___S215TW",
};

module.exports = exports;
